import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ITutor } from '../../../../../model/tutor.interface'
import apis from '../../../../apis'
import { getJwtToken } from '../../../../auth'
import QueryApi from '../../../../react-query/queryApiClass'

interface IFeaturedTutoQueryApiSearchParams {
  duration: number
}

const featuredTutorsQueryApi = new QueryApi<void, IFeaturedTutoQueryApiSearchParams>({
  api: apis.tutor.featured,
})

export const useFeaturedTutorList = (duration) => {
  const token = getJwtToken()

  const searchParams = { duration }

  return useQuery<ITutor[], AxiosError>({
    queryKey: featuredTutorsQueryApi.getQueryKey({ searchParams }),
    queryFn: featuredTutorsQueryApi.getQueryFn({ searchParams }),
    // onError: (error) => handleAxiosError(error),
    enabled: !!token && !!duration,
    refetchOnWindowFocus: false,
  })
}
